/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './timeline.stache';
import FeedDataService from 'scripts/services/timeline-feed-service';
import BaseList from 'scripts/models/base/list';
import can from 'can';
import device from 'scripts/utils/device';

Component.extend({
    tag: 'timeline',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            activeCategories: {
                Type: can.List,
                Value: can.List,
            },
            activeCard: {
                Type: can.Map,
                Value: null,
            },
            activeCardIndex: {
                type: 'number',
                value: null,
            },
            playersList: {
                Type: can.List,
                Value: can.List,
            },
            cards: {
                Type: BaseList,
                Value: BaseList,
            },
            loading: {
                type: 'boolean',
                value: false,
            },
            loadMore: {
                type: 'boolean',
                value: false,
            },
            currentPage: {
                type: 'number',
                value: 1,
            },
            filter: {
                Type: can.Map,
                Value: can.Map,
            },
            type: {
                type: 'string',
                value: '',
            },
            options: {
                Type: can.Map,
            },
        },

        onFilterChange(event) {
            if (event && event.payload) {
                let filter = this.attr('filter');
                filter.attr(event.payload);
                this.attr('activeCard', null);
            }
        },

        loadCards() {
            const type = this.attr('type');
            if (!this.attr('filter.type')) {
                return;
            }
            if (type === 'latest') {
                this.timelineLoader.loadLatest(
                    this.attr('filter.type'),
                    this.attr('currentPage'),
                );
            }
            if (type === 'player') {
                this.timelineLoader
                    .loadPlayer(
                        this.attr('filter.type'),
                        this.attr('options.identifier'),
                        this.attr('currentPage'),
                    )
                    .then((data) => {
                        if (data.activeCategories) {
                            this.attr(
                                'activeCategories',
                                data.activeCategories,
                            );
                        }
                    });
            }
        },

        pushCards(cards) {
            const cardIds = this.attr('cards').map((card) => card.identifier);

            const resultCards = cards.filter((card) => {
                if (
                    card.network === 'facebook' &&
                    device.isIE() &&
                    !device.isEdgeIE
                ) {
                    return false;
                }

                return cardIds.indexOf(card.identifier) === -1;
            });

            this.attr('cards').pushAll(resultCards);
        },
    },

    init: function() {
        this.viewModel.timelineLoader = new FeedDataService()
            .on('loading', (ev, data) => {
                if (!data) {
                    //timeout is used to guarantee set value by can
                    setTimeout(() => {
                        this.viewModel.attr('loading', false);
                    }, 0);
                } else {
                    this.viewModel.attr('loading', true);
                }
            })
            .on('data', (ev, cards, total, index) => {
                const filterType = this.viewModel.attr('filter.type');
                if (!filterType || filterType === 'all') {
                    this.viewModel.dispatch('dataAvailable', [
                        cards && cards.length > 0,
                    ]);
                }

                this.viewModel.pushCards(cards);

                this.viewModel.attr('loadMore', total && total > index);
            })
            .on('error', (error) => {
                this.viewModel.dispatch('dataAvailable', [false]);
                this.viewModel.attr('loading', false);
                this.viewModel.attr('loadMore', false);
            });
        this.viewModel.loadCards();
        this.viewModel
            .attr('filter')
            .bind('change', this.reloadCards.bind(this));
    },

    reloadCards() {
        this.viewModel.attr('cards').replace([]);
        this.viewModel.attr('currentPage', 1);
        this.viewModel.loadCards();
    },

    events: {
        '.s-btn--more click': function() {
            this.viewModel.attr(
                'currentPage',
                this.viewModel.attr('currentPage') + 1,
            );
            this.viewModel.loadCards();
        },
    },
});
